import React from 'react';
import styled from 'styled-components';
import logo from '@design-system/Assets/sella_white.png';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

const Main = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;

  .footer-content {
    background: #003232;
    height: auto;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    padding: 16px 16px;
    box-sizing: border-box;
  }

  .social_media {
    display: flex;
    gap: 26px;
  }

  .copyright {
    font-size: 16px;
    font-weight: 400;
  }

  p {
    color: #fff;
    margin: 0;
    font-size: 10px;
    font-weight: 400;
  }

  ${mediaQuery.desktop`
  position: relative;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  left: 0;

  p {
    color: #fff;
    margin: 0;
    font-size: 10px;
    font-weight: 400;
  }

  .footer-content {
    background: #003232;
    flex-direction: row;
    height: 128px;
    color: #fff;
    display: flex;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    padding: 0px 40px;
    box-sizing: border-box;
  }

  .social_media {
    display: flex;
    gap: 26px;
  }

  .copyright {
    font-size: 16px;
    font-weight: 400;
  }
  
  `}
`;

const Footer = () => {
  return (
    <Main>
      <div className="footer-content">
        <div>
          <p>Powered by</p>

          <img src={logo} alt="logo" />
        </div>

        <div className="copyright">© 2023. All rights reserved.</div>
      </div>
    </Main>
  );
};

export default Footer;
